import { loadLanguageAsync } from "@/setups/i18n.js"

export default {
	addToastMessage({ commit }, { type, content, cb, delay = 10000, preventAutoClose = false }) {
		const key = new Date().getTime() + ~~(Math.random() * 100000)
		const obj = {}
		obj[key] = { type, content, key, cb }
		commit("addToastMessage", obj)

		// Automatically remove messages after a few seconds
		if (preventAutoClose === false) {
			const timeout = setTimeout(() => {
				commit("removeToastMessage", key)
				clearTimeout(timeout)
			}, delay)
		}
	},

	removeToastMessage({ commit }, payload) {
		commit("removeToastMessage", payload)
	},

	async switchLocale({ commit }, locale) {
		let res
		try {
			res = await loadLanguageAsync(locale)
			res = { isSucces: true, locale }
			commit("setLocale", locale)
		} catch (error) {
			res = { isSucces: false, error }
		}

		return res
	}
}
